import { NodeViewContent } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';
import { useCallback, useEffect, useRef, useState } from 'react';

import { IconTrash } from '@xing-com/icons';

import { useImageAlt } from '../../../use-image-alt';

import { Styled } from './styles';

export const XingImageView: React.FC<NodeViewProps> = ({
  editor,
  node,
  deleteNode,
  updateAttributes,
  getPos,
}) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [loaded, setLoaded] = useState<boolean>(false);

  const imageAttrs = node.content?.firstChild?.attrs;
  const imageURL = imageAttrs?.src;

  const isHiddenImageContent = useImageAlt({ editor, node, getPos });

  const handleLoading = useCallback(() => {
    setLoaded(true);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!loaded && imageRef.current?.complete) {
      handleLoading();
    }
    updateAttributes({
      ['data-testid']: 'xing-image', // Adding data-testid attribute for testing purposes
    });
  }, [loaded, handleLoading]);

  return (
    <Styled.NodeViewWrapper className="react-component" loaded={loaded}>
      {imageURL && loading ? (
        <div contentEditable={false}>
          <Styled.ImageSkeletonContainer>
            <Styled.ImageSkeleton />
          </Styled.ImageSkeletonContainer>
          <img
            ref={imageRef}
            hidden
            src={imageURL}
            alt="body"
            onLoad={() => handleLoading()}
          />
        </div>
      ) : editor.isEditable ? (
        <Styled.ExcludeButton
          icon={IconTrash}
          size="medium"
          variant="tertiary"
          onClick={deleteNode}
        />
      ) : null}

      <NodeViewContent
        className="xing-image-content"
        as="figure"
        aria-hidden={isHiddenImageContent}
      />
    </Styled.NodeViewWrapper>
  );
};
